<template>
  <Manual v-if='runDocumentsLoaded'/>
</template>

<script>
  import { mapState } from 'vuex';
  import LoadingState from '@/api/LoadingState';
  import Manual from '../components/Manual'

  export default {
    name: 'ManualPage',

    components: {
      Manual,
    },
    computed: {
      ...mapState({
        runDocumentsLoaded: (state) => state.run.loadingState.runDocuments === LoadingState.LOADED,
        runDocuments: (state) => state.run.runDocuments,
      })
    },
    mounted() {
      if (!this.runDocumentsLoaded || this.runDocuments.length <= 0) {
        this.$api.run.getDocumentNames();
      }
    }
  }
</script>
